!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("ati-ui-react/components/icons/Icon")) : "function" == typeof define && define.amd ? define("ati-ui-react", ["react", "ati-ui-react/components/icons/Icon"], t) : "object" == typeof exports ? exports["ati-ui-react"] = t(require("react"), require("ati-ui-react/components/icons/Icon")) : e["ati-ui-react"] = t(e.React, e[void 0]);
}(this, function (r, n) {
  return u = {}, o.m = i = {
    0: function (e, t) {
      e.exports = r;
    },
    1: function (e, t) {
      e.exports = n;
    },
    744: function (e, t, r) {
      "use strict";

      r.r(t), r.d(t, "default", function () {
        return o;
      });
      var t = r(0),
        n = r.n(t),
        t = r(1),
        r = r.n(t),
        t = function (e) {
          var t = e.color,
            e = e.fillRule;
          return n.a.createElement("path", {
            fill: t,
            fillRule: e,
            d: "M8.482 0c4.684 0 8.481 3.824 8.481 8.543 0 4.898-3.691 10.284-6.255 12.966A66.344 66.344 0 0 0 8.481 24s-1.116-1.408-2.075-2.452C3.841 18.748 0 13 0 8.543 0 3.824 3.797 0 8.482 0zm0 13.193a4.712 4.712 0 1 0 0-9.423 4.712 4.712 0 0 0 0 9.423z"
          });
        };
      t.svg = {
        viewBox: "0 0 17 24"
      };
      var o = r()(t);
    }
  }, o.c = u, o.d = function (e, t, r) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (t, e) {
    if (1 & e && (t = o(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var r = Object.create(null);
    if (o.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var n in t) o.d(r, n, function (e) {
      return t[e];
    }.bind(null, n));
    return r;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 744);
  function o(e) {
    if (u[e]) return u[e].exports;
    var t = u[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return i[e].call(t.exports, t, t.exports, o), t.l = !0, t.exports;
  }
  var i, u;
});